import { Container, Divider, Drawer, PanelButton, Stack, Text } from 'shell/components';

const Mobile = ({ options, selected, onChange }) => {
    const renderContent = () => {
        return options.find(({ key }) => key === selected)?.content || null;
    };

    return (
        <>
            <Container device={'mobile'}>
                <Stack sx={{ width: '100%' }} spacing={2}>
                    <Text component={'h1'} variant={'h6'}>
                        Course Settings
                    </Text>
                    <Stack sx={{ width: '100%' }} divider={<Divider />}>
                        {options.map((option) => (
                            <PanelButton key={option.key} onClick={() => onChange(option.key)}>
                                <Text align={'left'} variant={'sh2'}>
                                    {option.value}
                                </Text>
                            </PanelButton>
                        ))}
                    </Stack>
                </Stack>
            </Container>
            <Drawer device={'mobile'} open={selected !== ''}>
                {renderContent()}
            </Drawer>
        </>
    );
};

export default Mobile;
